<template>
  <section class="iq-style1">
    <b-container class="py-5 text-center">
      <b-row class="d-flex justify-content-center mb-5 p-3">
        <curva-title :title="$t('main.clubs')"></curva-title>
      </b-row>
      <b-row class="mb-5 d-flex justify-content-center" cols="3" v-if="topClubs.length > 0">
        <b-col class="d-flex justify-content-center p-3" lg="2" sm="3" v-for="(club, key) in topClubs" :key="key">
          <router-link :to="{ name: 'clubDetails', params:{id: club.id} }">
            <div class="mb-4">
              <img class="club-img mb-1" :src="club.image">
              <h4>{{ club.name }}</h4>
            </div>
          </router-link>
        </b-col>
      </b-row>
      <b-spinner class="mb-5" v-else variant="warning" type="grow" label="Spinning"></b-spinner>
      <b-row class="d-flex justify-content-center p-3">
        <b-button class="curva-transparent-btn" @click="$router.push({ name:'topClubs'})">
          {{ $t('main.statistics') }}</b-button>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  props: {
    topClubs: { type: Array }
  }
}
</script>
<style>
.club-img {
  width: 108px;
  /*height: 120px;*/
}
@media only screen and (max-width: 500px){
  .club-img {
    width: 90px;
  }
}
</style>
